<div class="overlay-container" (window:resize)="onResize()" (window:scroll)="onResize()" [hidden]="!showOverlay">
  <div class="body" id="overlay-body" [style.paddingTop.px]="topOffset">
    <template #component></template>
  </div>
</div>
